import topicsDir from "../__topicsDir";

/**
 * events data
 * イベント一覧データ
 * @props {string} date 日時（YYYY-MM-DD\THH:mm）
 * @props {string} title タイトル（html）
 * @props {string} [href] リンクURL
 */
export default [
	{
		date: "2021-08-17T12:00",
		title: `
<h4>新潟県医師会在宅医療推進センター（基幹センター）より</h4>
<p class="paragraph-indent">
●第８回新潟県在宅医療推進センターコーディネーター研修会開催のご案内<br>
参加対象：郡市医師会在宅医療推進センターコーディネーター<br>
・<a href="${topicsDir}/2021/08-oordinator_training.pdf">第８回新潟県在宅医療推進センターコーディネーター研修会WEB開催のご案内</a>
</p>
		`.trim().replace(/\t|\n/g, "")
	}
];
